import React, { useState } from "react";

function Tenders() {
  const bulletins = [
    { id: 1, date: "2026-02-12" },
    { id: 2, date: "2026-02-05" },
    { id: 3, date: "2026-01-29" },
    { id: 4, date: "2026-01-22" },
    { id: 5, date: "2026-01-15" },
    { id: 6, date: "2026-01-08" },
    { id: 7, date: "2026-01-01" },
    { id: 8, date: "2025-12-25" },
    { id: 9, date: "2025-12-18" },
    { id: 10, date: "2025-12-11" },
    { id: 11, date: "2025-12-04" },
    { id: 12, date: "2025-11-27" },
  ];

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  return (
    <div className="container my-5">
      <div className="card shadow-sm border-0 rounded-4 p-4">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          <h3 className="fw-bold text-uppercase text-primary">
            Tender & Notices
          </h3>

          {/* Date Filter */}
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <div className="d-flex align-items-center gap-2">
              <label className="fw-semibold">From:</label>
              <input
                type="month"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <label className="fw-semibold">To:</label>
              <input
                type="month"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <button className="btn btn-primary px-4">
              Search
            </button>
          </div>
        </div>

        <hr />

        {/* Bulletin List */}
        <div className="row g-4 mt-2">
          {bulletins.map((item) => (
            <div key={item.id} className="col-md-6">
              <div className="border rounded-3 p-3 d-flex justify-content-between align-items-center shadow-sm bg-light hover-card">

                <span className="fw-semibold">
                  New Tender - {item.date}
                </span>

                <img
                  src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                  alt="pdf"
                  width="30"
                />
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Tenders;


